import React from 'react';
import PrepareJE from './PrepareJE';
import Layout from '../../../components/Layout';
import { Account } from '../../../variables/types';

interface Props {
  scheduleDate: string;
  accountBalance: Account;
}

const PrepareJEContainer = ({
  scheduleDate,
  accountBalance,
}: Props) => (
  <Layout title="Prepare JE">
    <PrepareJE
      scheduleDate={scheduleDate}
      accountBalance={accountBalance}
    />
  </Layout>
);

export default PrepareJEContainer;
